import { StrategicImperative } from '../../../shared/queries/strategicImperatives'

export const getLinkedActivityCount = (strategicImperative: StrategicImperative) =>
    strategicImperative.linkedActivities?.length ?? 0

export const getLinkedValueMessageCount = (strategicImperative: StrategicImperative) =>
    strategicImperative.linkedValueMessages?.length ?? 0
